import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./i18n"
import {isAuthGuardEnabled, isFramed, redirectToLogin} from "@/utils/authGuard";

// Opened outside the console iframe: no way to receive a session, go to login.
if (isAuthGuardEnabled() && !isFramed()) {
    redirectToLogin()
} else {
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}
